import utils from 'utils'
import globalFnFactory from 'components/globalFn/globalFnFactory'
import Invoice from '../invoice1/model/Invoice'
import Customer from '../invoice1/model/Customer'
import Ukey from '../invoice1/model/Ukey'
import {
    scanSubmitCheck
} from '../invoice1/invoiceValidate'

const globalFn = globalFnFactory()
export default class editCtrl {
    constructor($scope, httpRequest, $state, $stateParams, $http, logger, invoiceOpenService,scrollService) {
        httpRequest.post_getEnableBankOfOrg().then(res => {
            $scope.saleBankList = res.data.value
        })
        $scope.number = 1 // 默认生成1张二维码
        // 是否详情页 默认值
        $scope.detailFlag = $stateParams.detailFlag // 是详情页
        // 如果是控制台则增加样式
        if ($state.current.name.indexOf('workspace') > -1) {
            $scope.haveBorder = true
        }
        // 隐藏一二级菜单
        if ($stateParams.detailFlag === true) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        $scope.totalInvoice = 1
        $scope.currentInvoice = 1
        $scope.waitId = $stateParams.waitId
        let paramArr = []
        if ($stateParams.waitId) {
            paramArr = $stateParams.waitId.split('options')
            $scope.waitId = paramArr[0]
            if (paramArr.length > 1) {
                const invoiceArr = JSON.parse(paramArr[1])
                $scope.totalInvoice = invoiceArr.length
                $scope.currentInvoice = invoiceArr.indexOf($scope.waitId) + 1
            }
        }
        $scope.showOperateBtn = function (flag) {
            $scope.showOperate = flag
            if ($scope.currentInvoice > 1 && $scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = true
            } else if ($scope.currentInvoice > 1) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = false
            } else if ($scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = false
                $scope.showOperateRight = true
            }
        }
        // 翻页按钮
        $scope.changepage = function (val) {
            const list = JSON.parse(paramArr[1])
            if (val > 0) {
                $state.go('workspace.item.detail', {
                    waitId: `${list[$scope.currentInvoice]}options${JSON.stringify(list)}`,
                })
            } else {
                $state.go('workspace.item.detail', {
                    waitId: `${list[$scope.currentInvoice - 2]}options${JSON.stringify(list)}`,
                })
            }
        }
        console.log($stateParams.waitId, $scope.waitId, $scope.totalInvoice, $scope.currentInvoice)
        /**
         * 根据开票点和发票种类获取库存数量和最新发票代码号码
         */
        function getStockByUkey() {
            invoiceOpenService.getStockByUkey(
                $scope.invoice.ukey.ukeyList,
                $scope.invoice.ukey.ukeyId,
                $scope.invoice.invType,
            ).then((obj) => {
                $scope.hintMsg = `剩余发票数量:${obj.sum}`
                // 扫码开票不需要传invoiceCode 和 invoiceNumber
                // $scope.invoice.invoiceCode = obj.invoiceCode
                // $scope.invoice.invoiceNumber = obj.invoiceNumber
            }, (error) => {
                $scope.hintMsg = error
                $scope.invoice.invoiceCode = ''
                $scope.invoice.invoiceNumber = ''
            })
        }
        /**
         * 根据发票开票点ID获取开票点对象
         */
        function getSelectedUkey() {
            let selectedUkey
            $scope.invoice.ukey.ukeyList.forEach((ukey) => {
                if ($scope.invoice.ukey.ukeyId === ukey.ukeyId) {
                    selectedUkey = ukey
                    // $scope.invoice.ukey = new Ukey().fromUkey(ukey)
                }
            })
            return selectedUkey
        }
        // 选择开票点
        $scope.changerUkeyId = function changerUkeyId() {
            getStockByUkey()
            const selectedUeky = getSelectedUkey()
            $scope.invoice.ukey = new Ukey().fromUkey(selectedUeky)
            getQuotasByUkey()
        }
        /**
         * 获取发票限额
         */
        function getQuotasByUkey() {
            httpRequest.get_getTaxDisk($scope.invoice.ukey.ukeyId).then((res) => {
                const data = res.data.value
                $scope.invoice.ukey.quotas['0'] = data.specialQuota
                $scope.invoice.ukey.quotas['2'] = data.generalQuota
                $scope.invoice.ukey.quotas['51'] = data.electronicQuota
                // 金税盘机器号
                $scope.invoice.diskNo = data.diskNo
                utils.loaded()
            })
        }
        // 分页获取详情数据
        function getwaitListpage(pageInfo) {
            httpRequest.post_getPageInvoiceWaitDetail(pageInfo).then((res) => {
                $scope.currentDetail = null
                $scope.currentDetail = res.data.value
                if ($scope.currentDetail.isLastPage && $scope.currentDetail.size < 20) {
                    $scope.detailWaitInfo.waitDetailList = $scope.detailWaitInfo.waitDetailList ? $scope.detailWaitInfo.waitDetailList.concat($scope.currentDetail.list) : [].concat($scope.currentDetail.list)
                } else {
                    $scope.detailWaitInfo.waitDetailList = $scope.currentDetail.list
                }
                $scope.invoice = new Invoice($scope.detailWaitInfo)
                $scope.newDetails = []
                $scope.newDetails = $scope.invoice.details
                utils.loaded()
            })
        }
        $scope.loadSize = 20 // 默认一次跨度200条
        $scope.pageParam = {
            pageNum: 1,
            pageSize: $scope.loadSize,
            param: {
                invoiceID: $scope.waitId,
            },
        }
        /**
         * 初始化发票对象
         * @return {scope}
         */
        async function makeInvoice() {
            $scope.invoice = new Invoice()
            if ($scope.waitId) {
                const detailParam = {
                    waitId: $scope.waitId,
                }
                if ($stateParams.detailFlag) {
                    utils.loading('正在加载数据，请耐心等待......')
                    // 详情页needDetail=false 明细调用明细接口
                    detailParam.needDetail = false
                }
                httpRequest.get_queryOvatInvoiceWait(detailParam).then((res) => {
                    $scope.invoice = new Invoice(res.data.value)
                    if ($stateParams.detailFlag) {
                        $scope.detailWaitInfo = res.data.value
                        if ($scope.detailWaitInfo.isList === '0') {
                            $scope.invoice = new Invoice($scope.detailWaitInfo)
                            $scope.newDetails = []
                            $scope.newDetails = $scope.invoice.details
                            utils.loaded()
                        } else {
                            getwaitListpage($scope.pageParam)
                        }
                        // 有清单 总金额不按照列表结算，按列头赋值 --start
                        $scope.detailAdValoremTotal = $scope.detailWaitInfo.adValoremTotal
                        $scope.detailTotalAmt = $scope.detailWaitInfo.totalAmt
                        $scope.detailChineseTotal = globalFn.digitUppercase($scope.detailWaitInfo.adValoremTotal)
                        $scope.detailTotalTaxamt = $scope.detailWaitInfo.totalTaxamt
                        // 有清单 总金额不按照列表结算，按列头赋值 --end
                    } else {
                        $scope.isEdit = true
                        getStockByUkey()
                        getQuotasByUkey()
                    }
                })
            } else {
                $scope.invoice = new Invoice()
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.invType = $stateParams.invType
                $scope.changerUkeyId()
            }
            $scope.invoice.customer.creditType = '' // 扫码开票不需要默认值
        }
        // edit by fwc----->
        $scope.onScrollTop = function () {
            $scope.pageParam = scrollService.onScrollTop($scope.currentDetail,$scope.pageParam,$scope.loadSize,getwaitListpage) 
        }
        $scope.onScrollDown = function () {
            $scope.pageParam = scrollService.onScrollDown($scope.currentDetail,$scope.pageParam,$scope.loadSize,getwaitListpage)
        }
        // edit by fwc<-----
        /**
         * 获取清单最大行数作为invoice对象属性
         */
        function getGoodsLimit() {
            httpRequest.get_getLimitNumber('51').then((res) => {
                if (res.data.success) {
                    $scope.invoice.limitNumber = res.data.value
                }
            })
        }
        $scope.init = async function init() {
            makeInvoice()
            getGoodsLimit()
            const typecodeArr = ['zero_tax']
            $scope.dictionary = {}
            const disctDataRes = await httpRequest.get_dictByTypeArr(JSON.stringify(typecodeArr))
            Object.assign($scope.dictionary, disctDataRes.data.value)
            httpRequest.post_qryFlowIsValid({
                approveCode: 'opened_invoice_approve',
            }).then((res) => {
                // 开启审批流
                $scope.isFlowOpened = res.data.value
            })
        }

        $scope.init()
        $scope.selectedRows = []
        $scope.createTime = new Date()
        // TODO1 采用新的控件
        $scope.qryCustNameList = function qryCustNameList($item) {
            return $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, $item).then((response) => response.data.value.map((item) => $.extend({}, {
                custCodeAndcustName: `${item.customerName} ${item.creditCode}`,
            }, item)))
        }
        $scope.selectCust = function selectCust($item) {
            $scope.invoice.customer = new Customer().fromCustomer($item)
        }

        $scope.goListPage = function goListPage() {
            if ($scope.invoice.invType === '51') {
                $state.go('outputManage.FOManage.eleInvoice.list')
            } else {
                $state.go('outputManage.FOManage.invoice.list')
            }
        }
        // 生成二维码
        $scope.submit = function submit() {
            if (parseInt($scope.number) > 50) {
                logger.logError('最多生成50张单据')
                return
            }
            if (parseInt($scope.number) < 1) {
                logger.logError('最少生成1张单据')
                return
            }
            const invoiceDTO = $scope.invoice.toWaitDTO()
            const error = scanSubmitCheck(invoiceDTO)
            if (error) {
                logger.logError(error)
                return
            }
            const obj = {
                number: $scope.number,
                ovatInvoiceWait: invoiceDTO,
            }
            httpRequest.post_batchAddScanInvoiceWait(obj).then((res) => {
                // $state.go('outputManage.FOManage.eleInvoice.list')
                const url = $state.href('outputManage.FOManage.eleInvoice.printView', {
                    batchNo: res.data.value
                }, {
                    reload: true
                })
                window.open(url, '_blank')
            })
        }

        $scope.isListDisabled = function isListDisabled() {
            const {
                invoice
            } = $scope
            const {
                details
            } = invoice
            return (details[0] && details[0].balance !== 0) || details.length > invoice.getMaxRow()
        }
    }
}
editCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', '$http', 'logger', 'invoiceOpenService','scrollService']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/eleInvoice/edit.js